import React from 'react'

import FormWrapper from './Wrapper'
import Render from './Render'

const Form = ({
  schema,
  handlers = {},
  initialValues,
  validationSchema,
  error,
  onSubmit,
  onChange,
  children = () => {},
}) => {
  return (
    <FormWrapper
      schema={ schema }
      initialValues={ initialValues }
      validationSchema={ validationSchema }
      handlers={ handlers }
      onSubmit={ onSubmit }
      onChange={ onChange }
    >
      {
        ({
          isValid,
          values,
          errors,
          showErrors,
          touched,
          onSubmit,
        }) => {
          return (
            <>
              <Render
                fullHeight
                schema={ schema }
                handlers={ handlers }
                error={ error }
                isValid={ isValid }
                values={ values }
                errors={ errors }
                touched={ touched }
                showErrors={ showErrors }
                onSubmit={ onSubmit }
              />
              {
                children({
                  values,
                  isValid,
                  onSubmit,
                })
              }
            </>
          )
        }
      }
    </FormWrapper>
  )
}

export default Form